// extracted by mini-css-extract-plugin
export default {"signerLocation":"meJ9nUPk35QNHxDKthoK","labels":"RbOUZtbVajfVSi4lf2Gx","select":"RcHJyNj0PNlNi6fsXCHh","buttons":"IJw5uCkuCmP_6kNR5w4F"};